import { BaseModal } from './BaseModal'
import { GameStats } from '../../lib/localStorage'
import { PracticeStatBar } from '../stats/PracticeStatBar'
import { VerseTextWithSolution } from './VerseTextWithSolution'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  isGameLost: boolean
  isGameWon: boolean
  handleShareToClipboard: () => void
  isHardMode: boolean
  isDarkMode: boolean
  isHighContrastMode: boolean
  numberOfGuessesMade: number
  solution: string
  verse: string
  verseUrl: string
  verseText: string
  onPlayAgain: () => void
  practiceStats: GameStats
}

export const PracticeScriptureModal = ({
  isOpen,
  handleClose,
  guesses,
  isDarkMode,
  solution,
  verse,
  verseUrl,
  verseText,
  onPlayAgain,
  practiceStats,
}: Props) => {
  return (
    <BaseModal title={'Solution: ' + solution} isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-5 sm:mt-6 dark:text-white">
        <a
          href={verseUrl}
          target="_blank"
          className="underline font-bold text-blue-700"
          rel="noreferrer"
        >
          {verse}
        </a>{' '}
        - &quot;<VerseTextWithSolution verseText={verseText} solution={solution} />&quot;
      </div>

      <PracticeStatBar gameStats={practiceStats} />

      <div className="mt-5 sm:mt-6 px-20 dark:text-white">
        <button
          type="button"
          className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          onClick={onPlayAgain}
        >
          Play Again
        </button>
      </div>
    </BaseModal>
  )
}
